module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "vis-durations"
    }
  }, [_c('div', {
    staticClass: "list"
  }, _vm._l((_vm.words), function(word) {
    return _c('div', {
      staticClass: "record"
    }, [_c('div', {
      staticClass: "word"
    }, [_vm._v(_vm._s(word.text))]), _c('div', {
      staticClass: "duration"
    }, [_vm._v(_vm._s(word.value))])])
  })), _c('control-panel', {
    attrs: {
      "title": _vm.title,
      "feedback": _vm.feedback,
      "text-length": _vm.textLength,
      "initial-page-index": _vm.initialPageIndex,
      "options": _vm.options
    },
    on: {
      "page-changed": _vm.setPage,
      "show-options": _vm.showOptions,
      "close": _vm.close
    }
  }), _c('options', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOptionsDisplayed),
      expression: "isOptionsDisplayed"
    }],
    attrs: {
      "values": _vm.options
    },
    on: {
      "close": _vm.closeOptions,
      "apply": _vm.applyOptions
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f8a5885"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/vis/Durations.vue
// module id = 440
// module chunks = 0